var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 2048 2048",
    width: 128,
    height: 128,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1592,63)",
    d: "m0 0h24l30 2 21 3 20 5 26 9 27 13 27 16 15 11 13 10 13 11 24 24 9 11 14 18 7 11 9 15 12 23 12 30 6 20 6 29 5 30 1 9v29l-3 24-9 44-6 21-12 30-12 23-14 23-9 13-11 14-7 8h-2l-2 4-13 13-8 7-13 11-18 13-27 16-26 13-8 5-1 2v62h63l21 2 16 4 14 7 10 8 7 7 10 15 7 16 3 11 1 16-2 15-6 18-8 14-9 10-12 10-11 6-16 7 11-1 5-1h14l10 2 15 6 12 8 6 5 11 14 8 15 5 15 1 5v24l-5 17-10 19-12 13-8 6-15 7-18 6-11 2h-18l-9-2h-5l11 6 10 8v2l4 2 8 8 11 16 6 13 3 16v20l-2 17-7 14-10 13-4 5-12 9-21 10-17 4h-23l-8-2v2l6 2 15 10 10 8 7 7 11 18 4 10 2 8 1 12v11l-2 20-7 14-9 12-8 9-17 10-19 8-18 6-1 3 1 4v31l-1 101-1 370-1 19-2 12-6 12-13 18-10 10-9 6-16 2-24 1-49 1-601 1h-159l-21-1-17-3-9-6-10-9-7-6-11-14-7-13-3-19-1-15-1-52v-442l-11 2-76 11-19 2-24 1-25-1-27-4-38-9-16-5-21-9-17-8-24-14-16-11-11-9-13-11-10-8-6-3-209-1-22-1-7-3-3-12-1-15v-510l1-17 4-8 3-1 14-1 134-2 63-2 30-2 12-3 11-8 13-12 14-14 7-8 12-14 9-11 12-14 13-16 8-10 18-22 13-15 17-17 11-9 17-13 16-10 16-8 15-6 23-6 20-2h19l18 1 24 3h8l1-134v-83l1-50 3-16 8-16 8-10 10-10 12-9 8-4 13-3 45-1 98-1 10-4 9-1h29l26 1h315l10-5 9-9 7-8 12-14 20-20 11-9 8-7 16-11 22-13 21-11 28-11 24-7 26-5 16-2z",
    fill: "#D4E8FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(663,534)",
    d: "m0 0h19l18 1 24 3h8l1-3 12 2 20 6 24 8 26 11 23 12 18 11 16 12 13 11 14 14 12 16 9 15 8 17 6 19 3 14 3 41 3 122 2 62v41l-2 15-5 13-8 14-7 11-11 13-7 7-15 9-14 6-16 4-7 1h-23l-24-6-15-6-8-5-11-8-15-14-12-12v-2l-4-2-6-1-1 1-1 16-2 71-1 135-1 86-1 40-3 42-4 2-3 6-17 3-55 8-19 2-24 1-25-1-27-4-38-9-16-5-21-9-17-8-24-14-16-11-11-9-13-11-10-8-6-3-209-1-22-1-7-3-3-12-1-15v-510l1-17 4-8 3-1 14-1 134-2 63-2 30-2 12-3 11-8 13-12 14-14 7-8 12-14 9-11 12-14 13-16 8-10 18-22 13-15 17-17 11-9 17-13 16-10 16-8 15-6 23-6z",
    fill: "#F2D8C9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1592,63)",
    d: "m0 0h24l30 2 21 3 20 5 26 9 27 13 27 16 15 11 13 10 13 11 24 24 9 11 14 18 7 11 9 15 12 23 12 30 6 20 6 29 5 30 1 9v29l-3 24-9 44-6 21-12 30-12 23-14 23-9 13-11 14-7 8h-2l-2 4-13 13-8 7-13 11-18 13-27 16-26 13-8 5-1 2-1 38h-1l-1-7v-28l-26 7-26 4-42 6-10 1h-17l-27-4-24-5-28-8-20-7-23-10-16-8-25-14-10-7-12-8-16-13-12-11v-2l-4-2-7-8-10-12-10-13-9-13-11-18-10-18-10-21-9-23-7-22-5-22-2-11-2-22v-24l2-29 5-35 14-36 7-20 11-28 8-18 4-8 9-6 8-8 7-8 12-14 20-20 11-9 8-7 16-11 22-13 21-11 28-11 24-7 26-5 16-2z",
    fill: "#88C4FE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1219,838)",
    d: "m0 0h27l35 7 13 3v2l11 1 9 3v2l6 1 11 5 10 4 16 8 8 5 12 6 9 4 5 4v2l6 2 5 4 1 2 5 3 2 4 4 1 23 23 11 14 2 5 3 4 3 5 7 10 10 17 9 19 5 11 9 24 5 19 4 25 1 12v48l-3 32-4 18-7 23-2 7-15 33-5 9-10 16-9 13-11 14-9 10-7 8-14 14-14 11-14 10-15 9-23 12-16 7-11 4-9 3-20 6-10 2-30 3-6 1h-32l-21-3-17-2-4-1v-2l-9-1-6-2-10-2-7-2-16-5v-2l-11-2-9-4v-2l-5-1-12-6-9-2-22-14-14-12-10-9-10-10-1-3-5-4-2-4-3-2v-2h-2l-3-4v-4h-2l-2-4-5-5-1-3-3-1-4-6-7-10-9-17-3-6-6-13-2-6-4-9-3-8-2-12h-2l-7-35-3-23-1-11v-37l3-27 6-24 4-12h2l3-10 10-24 5-9 2-6h2l3-9 14-22 5-7 8-7 8-10 1-3 8-7 13-13 11-9 13-10 7-3 24-14 6-3 8-2 19-8 5-1v-2l23-7 17-4z",
    fill: "#FDC34C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(370,753)",
    d: "m0 0h11l1 5v121l-1 104v170l1 12v78l-1 27v57l-211-1-22-1-7-3-3-12-1-15v-510l1-17 4-8 3-1 14-1 134-2 63-2z",
    fill: "#CDD0D1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1710,733)",
    d: "m0 0 2 1v4h63l21 2 16 4 14 7 10 8 7 7 10 15 7 16 3 11 1 16-2 15-6 18-8 14-9 10-12 10-11 6-16 7 11-1 5-1h14l10 2 15 6 12 8 6 5 11 14 8 15 5 15 1 5v24l-5 17-10 19-12 13-8 6-15 7-18 6-11 2h-18l-9-2h-5l11 6 10 8v2l4 2 8 8 11 16 6 13 3 16v20l-2 17-7 14-10 13-4 5-12 9-21 10-17 4h-23l-8-2v2l6 2 15 10 10 8 7 7 11 18 4 10 2 8 1 12v11l-2 20-7 14-9 12-8 9-17 10-19 8-16 5h-2l-1-7-1-20-1-108-1-259 1-228v-35z",
    fill: "#F2D8C9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1216,915)",
    d: "m0 0h12l8 4 5 3 7 11 5 11 3 5 6 4 5 4 5 5 11 6 5 3v2h2v2l4 2 16 13 4 4 2 6h2l5 7 3 3 5 13 3 5 2 15v6l-7 11-3 6-7 4-13 2h-9l-9-5-6-7-5-5-5-6v-2l-4-2-8-9-8-5-18-6-18-1-16 1-10 3-6 4-8 10-4 4-1 9 5 14 6 4 5 5 13 5 3 2 14 3 36 9 9 3 11 5 9 3 20 11 10 8 13 13 5 7 6 12 3 9 4 17 1 14-1 14-1 10-4 11-8 16-8 10-13 12-5 4-12 7-5 3-8 3-10 7-11 6-4 5h-2l-3 11-7 8-8 9-12 6-13-3v-2l-5-2-7-9-6-11-8-8-3-6-5-4-14-8-11-7-10-9-2-1v-2l-4-2-4-5-7-5v-2h-2l-6-10-9-6-3-4v-12l-9-19 1-4 9-17 8-8 6-3h2v-2l2-1 16-1 9 5v2l4 1 6 9 4 9v2l3 1 7 14v2l5 2 3 3 4 2 2 3 13 3 7 3 19 2h10l13-3 10-2 11-8 5-3h2l2-6-1-13v-13l-7-2-6-6-13-6-4-2v-2l-7-2-26-3-6-3-16-4-10-4-10-3-12-5-11-6-9-8-7-8-4-4v-2h-2l-7-10-5-12-3-5-5-8-2-7v-18l3-14 7-20 6-11 3-5h2l2-4 11-12 5-5 11-9h3v-2l6-4 5-5 9-6 5-4 5-10 4-4 2-5h2l1-6 9-8 3-2z",
    fill: "#FFD67F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1731,240)",
    d: "m0 0h14l13 4 9 6 9 8 10 14 3 8v10l-7 12-8 10-12 14-9 10-4 5-32 32-7 8-40 40-7 8-29 29-6 7-8 7-14 14-8 7-14 12-13 9-9 4-4 1h-9l-10-4-10-6-18-14-11-9v-2l-4-2-8-8-16-14v-2l-4-2-37-37-7-8-10-12-8-16-2-9 1-13 5-12 4-6 9-10 10-7 10-4h13l12 5 11 7 16 13 45 42 8 7 4 4 5-2 11-8 7-7 8-7 8-8 8-7 28-28 7-8 46-46 8-7 9-9 11-9 11-8z",
    fill: "#D3E8FD"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1683,1354)",
    d: "m0 0 5 1 3 14 3 5 1 4 8-1 4 8 3 2 2 12v31l-1 101-1 370-1 13h-1l-2-31v-19l-1-58v-18l-1-12h-4l-1 3 1 4-4 4-2 6h-2l-2-12-3-9-3-1-5-1-1-5 2-12 1-3-3-2v-9l-2-5v-10l-3-8-1-3 3-3h2l-3-7 1-6-3-3 2-4-1-9 1-3-2-8-1-14 3-5-2-7-1-11v-6l3-6-4-2-1-2 2-5 1-11-1-2-1-12 1-3h2l-3-5-1-2 2-5 1-12-2-2 1-10 2-5-1-5-1-2v-9l2-3v-5l-1-1v-12l2-2-1-6-1-1v-8l3-4-1-6-1-1v-17l1-4 6-2-5-13-1-1v-5l5-8 1-6-5-1-1-5 5-3v-13l-3-7-1-1v-8l2-2 3-24z",
    fill: "#BDE2FD"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(332,755)",
    d: "m0 0h13v1l-5 1v3l-17 4-33 6-11 1-12 3-8 1-20 4-18 3-28 4-16 5-8 4-5 6-3 3-4 8-2 1-1 5h-2l-2 17v20l2 10v46l2 3-1 12v12l2 10-1 3v16l1 11-1 13 1 5v40l-1 12 1 4v37l-3 35-1 7 1 9v8l-1 4 1 8-2 9h-3l-2-3 2-10-3-10v-13l-1-7-1-11-3-2-2 1v-329l1-17 4-8 3-1 14-1 134-2z",
    fill: "#E1D9D5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(401,1317)",
    d: "m0 0h3l1 6 2-1 15 1 12 2 9 5 14 5 3 5v2l3-1 3 3 5 1v-2l4 1 2 6 7 2 5 1 2 3h-6l-2-1v2l-5-2-6-1 9 4 4 1 4 6 5-1 4 3 3-1 11 7 12 6v-2l5 2 6 2 3 3 5 3 1 4 8 1v-2l5 1 9 3h2l1-2h6l3 2h11l5 1 1 7-3-1 2 3 22 3 8-1 4 1h17l2 1 13 1 6-1v-2l11 3h3v2l-42 6-32 2-28-1-27-4-38-9-16-5-21-9-17-8-24-14-16-11-11-9-13-11-10-8-2-2 4-4 9-2z",
    fill: "#F6D7BA"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(981,228)",
    d: "m0 0h13l5 10 5 7 3 8 1 10h2l6 17 4 5v2l9 3 17 1h180l44-1h18l2 4-5 13-8 4h-142l-53-1-57-3-15-1-12-3-6-3v-2h-2l-3-9-7-24-4-10v-14l3-9z",
    fill: "#CED0D1"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(258,832)",
    d: "m0 0h9l11 2 10 6 6 7 3 6 1 4v18l-4 9-7 10-7 5-9 3-6 1h-9l-12-3-9-6-6-10-3-9-1-12 2-9 4-8 7-8 8-4z",
    fill: "#88C4FF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1743,1309)",
    d: "m0 0 13 5 5 2 1-2 14 1 5 2 1 7 5 1 1-5-3-1 1-7 5-1v16l-2 9-8 14-11 14-7 6-20 11-16 6-9 1-5-5v-36l2 3-1 2 2 1 3 1 1-3 2 1 4 8 3 1v-2l4 1 1 3 9-1 3-2 2-1 2-4 2 1 4-9 2-2-1-11h-2v-2l-8-4 2-2-3-5-2-2 2-1-1-5h-2z",
    fill: "#F6D6B9"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(332,755)",
    d: "m0 0h13v1l-5 1 1 2-13 2-15 1-34 1-36 2-48 4-17 4-18 7-14 7-3 7-2 10-2 9v103l-1 54h-1v-185l1-17 4-8 3-1 14-1 134-2z",
    fill: "#D4E9FD"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1227,1979)",
    d: "m0 0h395l-2 2-40 1-601 1h-154v-1l16-2z",
    fill: "#A5D4FD"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(376,753)",
    d: "m0 0h5l-2 18v11l-1 13-1 2v9l1 5-1 33-1 8v14l-1 18-2 16-1 3v16l-1 9v18l-1 1-1 7-5-4-1-4v-9l2-23-2-8v-18l1-3v-8l-2 1-1-16-1-8 3-3 2-3-3-9-2-1 1-7h2l3-7 1-10-3 1v-5h-2l-1 5h-1v-6l3-3h2l3-13 1-17 1-7 1-4 2-4v-3h2l-1-4z",
    fill: "#BEE2FC"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(986,228)",
    d: "m0 0h8l5 10 5 7 3 8 1 10h2l6 17 4 5v2l9 3 17 1h180l44-1h15l-4 2-34 2-53 1h-16l-51 1-33-1-6 1h-36l-25-1-8-3-8-6-3-7h-9v-3l4-10v-10l-3-1-3-6-2-7-4-6-5-3-1-4z",
    fill: "#E2D9D5"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1837,1146)",
    d: "m0 0h2l1 9-2 17-7 14-10 13-4 5-12 9-3-1 4-6 9-10 1-2h2l1-5 2-4v-6l-8-7 1-2-5-2 4-1h3l-3-1-2-5v-2l-2-3-3-1 1-2 5 2 6 1-1-3 10-2 1 2h4l1-5z",
    fill: "#F7D6B8"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1872,990)",
    d: "m0 0 10 2h6l6 9v9l-9 19-9 11-8 8-15 8h-3l1-3 1-2h3l1-3 4-2 2 1 1-3 6-3 3-1 3-5 1-6 4-4 1-2v-7l-6-5v-3-3h-2l-4-4-2-1 1-3-1-4 5-1z",
    fill: "#F6D7BA"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1225,835)",
    d: "m0 0h9l17 2 43 9 24 8 24 11 16 8 20 11 3 3-4-1-19-10-7-4-10-5-14-6-13-5v-2l-8-1-1-1-11-2v-2l-9-1-33-7-6-1h-27l-53 8-28 7-9 3h-3v2l-24 10-10 3-6 3-2-1 16-8 16-7 16-6 25-7 23-5 25-4z",
    fill: "#EFD7C7"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1286,442)",
    d: "m0 0 2 4 6 20 8 22 12 26 9 17 11 18 13 19 10 12 8 10 8 9 5 5 12 11 12 9-2 1-9-6v-2l-4-2-10-9-7-6v-2l-4-2v-2l-5-2-4-5v-2h-2l-7-9-4-5-12-16-6-9-5-10-6-11-5-10-7-17-9-24-7-22z",
    fill: "#BFE3FD"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(367,955)",
    d: "m0 0 1 2h2l1 2v38l1 2-1 10h-3v3l3-1-1 9-2 1 4 5v11l-2 10-5 1-3-4v-10l2-4h2l-1-9-1-2v-6l1-4v-10l-1-5 1-9-1-5-1-4 1-10v-7z",
    fill: "#BFE2FC"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1704,679)",
    d: "m0 0h5l-1 3h-4l-5 2-2 4-5 5-5 2h-13l-5-1h-20l-41 4h-23l-19-3v-1h9l13 2h17l61-8 20-4z",
    fill: "#BFE3FD"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(366,1048)",
    d: "m0 0 2 4h2l2 6v7l-3 13 2 3v19l-2 13-3-6-2 2-2-16 1-6 1-2v-11l-2-5 1-15z",
    fill: "#BFE3FD"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(137,1260)",
    d: "m0 0 2 4 2 5 4 30 1 9 1 2v6l-3 2-1 5-3-3-2-10-1-15z",
    fill: "#E0DAD7"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1291,291)",
    d: "m0 0 1 3-5 13-5 35-2 29v24l2 22 4 21-1 4-3-12-4-24-1-16v-22l4-48v-10l2-3h2l1-5 4-9z",
    fill: "#BFE3FD"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(943,894)",
    d: "m0 0h1l1 34v41l-2 15-5 13-8 14-7 11-2 1 2-5 9-16 7-16 3-14 1-38z",
    fill: "#E2D9D5"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1219,838)",
    d: "m0 0h27l16 3v1l-11-1-6-1h-22l-27 5-32 4-28 7-6 2-4-1 23-7 17-4z",
    fill: "#FFD67F"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(715,1392)",
    d: "m0 0h6v4l-3 9-17 3h-6l1-4h2l1-2 5-2 4-1v-2h2v-2h2v-2z",
    fill: "#F6D7BA"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(366,1048)",
    d: "m0 0 2 4h2l2 6v7l-3 13-2 5h-1l-3-11-1-9 1-9z",
    fill: "#BFE2FB"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1534,1979)",
    d: "m0 0h88l-2 2-40 1h-33l-13-1z",
    fill: "#BCE1FD"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1278,1407)",
    d: "m0 0h6v1l-19 3-19 2-3 1-25 1-34-6v-1l12 1 14 2h32l23-3z",
    fill: "#F6D7B5"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1293,847)",
    d: "m0 0 7 1 18 6 24 11 16 8 20 11 3 3-4-1-19-10-7-4-10-5-14-6-13-5v-2l-8-1-1-1-11-2z",
    fill: "#F7D7AE"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1856,835)",
    d: "m0 0h3l2 4-1 7-5 12h-2l-2-5h2l-2-7v-2-4-2l-2-1 7-1z",
    fill: "#F6D7BB"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1145,849)",
    d: "m0 0 3 1-6 3-13 4h-3v2l-24 10-10 3-6 3-2-1 16-8 16-7 16-6z",
    fill: "#F2D7B4"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(402,1343)",
    d: "m0 0 6 1 8 5 8 6 8 9v2l-5-2-13-10-12-10z",
    fill: "#F3D8C9"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1018,1327)",
    d: "m0 0 4 2 11 11 8 7 16 12 18 11v2l4 2-5-1-22-14-14-12-10-9-10-10z",
    fill: "#F9D6A1"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1724,739)",
    d: "m0 0 14 1h19l6 1h15l5 1v1h-54z",
    fill: "#F7D7BA"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(727,1339)",
    d: "m0 0h1v16l-3 42-4 1 1-2 2-19 2-37z",
    fill: "#D3D2D2"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1057,890)",
    d: "m0 0 2 1-5 5-3 1-2 3h-3v2l-6 4-4 4-8 7-6 7-9 7-1-2 8-7 13-13 11-9z",
    fill: "#F8D6A4"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(982,268)",
    d: "m0 0h3l3 6 2 2v14l-2 1-5-16z",
    fill: "#E2D9D5"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1079,1374)",
    d: "m0 0 6 1 12 6 3 1v2l9 3 11 3v2l3 1-7-1-13-5-23-11z",
    fill: "#EFD7C1"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(949,1036)",
    d: "m0 0h1l-1 9-4 16-4 12-2 11h-1l1-12 6-24z",
    fill: "#F7D7AA"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1708,691)",
    d: "m0 0h1l2 23v19l-2 1-1-12z",
    fill: "#BFE3FD"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1850,864)",
    d: "m0 0 1 2-6 9-5 5-2-1 3-8 3-1 2-4z",
    fill: "#F6D7BB"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1412,910)",
    d: "m0 0 7 6 18 18 5 6v2l-4-2-7-9-19-19z",
    fill: "#F9D6A1"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1785,1333)",
    d: "m0 0 4 1-2 6-5 8h-1v-9l3-5z",
    fill: "#F3D8C9"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1785,1275)",
    d: "m0 0 3 3 3 12v3l-3-1-3-4-1-9z",
    fill: "#F7D6B2"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1834,1117)",
    d: "m0 0h2l3 10v6l-5-4-1-9z",
    fill: "#F7D4AA"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(368,1322)",
    d: "m0 0h9l2 4-23-1 3-2z",
    fill: "#88C4FF"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1171,844)",
    d: "m0 0h8v1l-17 3-15 3 3-3 11-3z",
    fill: "#F0D7C4"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1790,1311)",
    d: "m0 0h1v11l-6-3 1-7z",
    fill: "#F8D3A3"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(476,1390)",
    d: "m0 0 9 1 11 6 1 2-5-1-16-7z",
    fill: "#F3D8C9"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(824,1980)",
    d: "m0 0h11l-4 2-11 1-17-1v-1z",
    fill: "#BFE3FD"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(725,1377)",
    d: "m0 0h1v10l-1 10-4 1 1-2 2-18z",
    fill: "#CED0D1"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(363,1319)",
    d: "m0 0h8l6 2-4 2-11 1-3-2 3-1z",
    fill: "#BFE3FD"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1079,1374)",
    d: "m0 0 6 1 12 6 3 2h-6l-15-8z",
    fill: "#F7D6A3"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1712,1380)",
    d: "m0 0 4 5 4 4-8 2-1-10z",
    fill: "#F1D8CA"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(223,858)",
    d: "m0 0h2v16l-2-1-1-3v-10z",
    fill: "#E2D9D5"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1683,1343)",
    d: "m0 0 4 1-1 9h-3l-1-7z",
    fill: "#BFE3FD"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(351,1323)",
    d: "m0 0h8v1l11 1v1h-21l-1-2z",
    fill: "#C6D9E6"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1180,841)",
    d: "m0 0h6l-1 3-19 1 4-2z",
    fill: "#EAD8CD"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1293,847)",
    d: "m0 0 7 1 10 3v1l-12-1-4-1z",
    fill: "#F3D7B8"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1063,1365)",
    d: "m0 0 6 1 6 4v2l4 2-5-1-11-7z",
    fill: "#F8D6A7"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(139,1096)",
    d: "m0 0 3 3-1 5-1 2h-2v-9z",
    fill: "#CED0D1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCheck);
export default __webpack_public_path__ + "static/media/close-check.72a1e39547721670c5ac0dc3a46428c2.svg";
export { ForwardRef as ReactComponent };